/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeviceLocationPermission } from './DeviceLocationPermission';
import {
    DeviceLocationPermissionFromJSON,
    DeviceLocationPermissionFromJSONTyped,
    DeviceLocationPermissionToJSON,
    DeviceLocationPermissionToJSONTyped,
} from './DeviceLocationPermission';
import type { LocationPreference } from './LocationPreference';
import {
    LocationPreferenceFromJSON,
    LocationPreferenceFromJSONTyped,
    LocationPreferenceToJSON,
    LocationPreferenceToJSONTyped,
} from './LocationPreference';

/**
 * 
 * @export
 * @interface UserLocationTrackingPreferenceRequest
 */
export interface UserLocationTrackingPreferenceRequest {
    /**
     * 
     * @type {DeviceLocationPermission}
     * @memberof UserLocationTrackingPreferenceRequest
     */
    device_location_permission: DeviceLocationPermission;
    /**
     * 
     * @type {LocationPreference}
     * @memberof UserLocationTrackingPreferenceRequest
     */
    user_location_preference: LocationPreference;
}



/**
 * Check if a given object implements the UserLocationTrackingPreferenceRequest interface.
 */
export function instanceOfUserLocationTrackingPreferenceRequest(value: object): value is UserLocationTrackingPreferenceRequest {
    if (!('device_location_permission' in value) || value['device_location_permission'] === undefined) return false;
    if (!('user_location_preference' in value) || value['user_location_preference'] === undefined) return false;
    return true;
}

export function UserLocationTrackingPreferenceRequestFromJSON(json: any): UserLocationTrackingPreferenceRequest {
    return UserLocationTrackingPreferenceRequestFromJSONTyped(json, false);
}

export function UserLocationTrackingPreferenceRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserLocationTrackingPreferenceRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'device_location_permission': DeviceLocationPermissionFromJSON(json['device_location_permission']),
        'user_location_preference': LocationPreferenceFromJSON(json['user_location_preference']),
    };
}

export function UserLocationTrackingPreferenceRequestToJSON(json: any): UserLocationTrackingPreferenceRequest {
    return UserLocationTrackingPreferenceRequestToJSONTyped(json, false);
}

export function UserLocationTrackingPreferenceRequestToJSONTyped(value?: UserLocationTrackingPreferenceRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'device_location_permission': DeviceLocationPermissionToJSON(value['device_location_permission']),
        'user_location_preference': LocationPreferenceToJSON(value['user_location_preference']),
    };
}

